module.exports = __webpack_public_path__ + "static/media/bubble-7-tablet.0155aef4.svg";